// El fondo de celdas de la portada de Redes — el `BackgroundRippleEffect` de Aceternity
// que pasó Matías, portado a este repo (ADR-2026-10-02-redes-fondo-de-celdas): una grilla
// de cuadraditos apenas visibles detrás del título y la caja, que se desvanece hacia abajo
// y, al tocar una celda, manda una onda desde ahí. Sin `cn`, sin dark mode y sin las
// utilidades de máscara de Tailwind v4 (acá la máscara es un `radial-gradient` en línea).
// La animación de la onda (`animate-cell-ripple`) vive en `index.css`.

import React, { useMemo, useState } from 'react';

const BORDE = '#CFD3DF';
const RELLENO = '#ECEEF4';

export const FondoDeCeldas: React.FC<{
  filas?: number;
  columnas?: number;
  lado?: number;
  className?: string;
}> = ({ filas = 14, columnas = 44, lado = 56, className = '' }) => {
  const [tocada, setTocada] = useState<{ fila: number; col: number } | null>(null);
  // Cambia con cada toque: remonta la grilla para que la onda vuelva a arrancar.
  const [onda, setOnda] = useState(0);
  const celdas = useMemo(() => Array.from({ length: filas * columnas }, (_, i) => i), [filas, columnas]);

  return (
    <div aria-hidden="true" className={`absolute inset-0 overflow-hidden ${className}`}>
      <div
        key={onda}
        className="relative mx-auto"
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columnas}, ${lado}px)`,
          gridTemplateRows: `repeat(${filas}, ${lado}px)`,
          width: columnas * lado,
          height: filas * lado,
          // Se ve arriba y se funde hacia abajo y hacia los costados.
          maskImage: 'radial-gradient(ellipse 75% 100% at 50% 0%, black 45%, transparent 100%)',
          WebkitMaskImage: 'radial-gradient(ellipse 75% 100% at 50% 0%, black 45%, transparent 100%)',
        }}
      >
        {celdas.map((i) => {
          const fila = Math.floor(i / columnas);
          const col = i % columnas;
          const distancia = tocada ? Math.hypot(tocada.fila - fila, tocada.col - col) : 0;
          return (
            <div
              key={i}
              onClick={() => {
                setTocada({ fila, col });
                setOnda((k) => k + 1);
              }}
              className={`relative border-[0.5px] opacity-70 transition-opacity duration-150 will-change-transform hover:opacity-100 ${tocada ? 'animate-cell-ripple' : ''}`}
              style={
                {
                  backgroundColor: RELLENO,
                  borderColor: BORDE,
                  ...(tocada ? { '--delay': `${Math.max(0, distancia * 55)}ms`, '--duration': `${200 + distancia * 80}ms` } : {}),
                } as React.CSSProperties
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default FondoDeCeldas;
